export const LODGIN_TYPES = {
    CL: 'Lodging',
    VR: 'PrivateResidence'
};

const ClassificationAction = {

    SET_LODGING_PREFERENCE: 'SET_LODGING_PREFERENCE',
    setLodgingPreference: lodgingPreference => ({
        type: ClassificationAction.SET_LODGING_PREFERENCE,
        lodgingPreference,
        persist: true
    })
};

export default ClassificationAction;
